import React from "react"
import Text from "antd/lib/typography/Text"
import { User } from "../../../user/types"

interface Props {
  user?: User
}

export const UserEmail = ({ user }: Props) => (
  <Text
    style={{
      textTransform: "capitalize",
    }}
  >
    {user ? user.data.email : ""}
  </Text>
)
